export enum ProviderAccordionSelectedTab {
  NetworkProviders,
  OutOfNetworkProviders,
}

export enum ProvidersSortOptions {
  Alphabetical,
  ReverseAlphabetical,
  ServesHighToLow,
  ServesLowToHigh,
  GainsHighToLow,
  GainsLowToHigh,
  ImpactsHighToLow,
  ImpactsLowToHigh
}

export enum ProvidersFilterOptions {
  Network = 'network',
  NonTerminated = 'nonTerminated',
  Terminated = 'terminated',
  Market = 'market',
  AvailableMarket = 'availableMarket',
  TargetedMarket = 'targetedMarket',
  ExcludedMarket = 'excludedMarket',
  Prospect = 'prospect',
  AvailableProspect = 'availableProspect',
  TargetedProspect = 'targetedProspect',
  ExcludedProspect = 'excludedProspect',

  // Only for when the advanced filters feature flag is disabled
  Target = 'target',
  Excluded = 'excluded',
}

export enum InsufficientClaimsVolumeLabels {
  InsufficientDataNew = "Insufficient Data - New",
  InsufficientDataStateLOB = "Insufficient Data - State/LOB",
  InsufficientDataSpecialty = "Insufficient Data - Specialty",
  InsufficientDataIndirectCare = "Insufficient Data - Indirect Care",
}

export enum ProviderFetchMessageStatus {
  Error,
  Unavailable,
  Available,
}

export enum NetworkCoverageMapMembershipType {
  Primary = "Primary",
  Secondary = "Secondary",
}